// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "partnershipFrontend/js/" + chunkId + "." + "9f2ba5fb" + ".chunk.js";
};